export default {
  home: '/',  
  login: '/ingreso',
  loginCode: '/ingreso-codigo',
  logout: '/salir',
  profile: '/perfil',
  recoverPassword: '/contrasena',
  registration: '/registro',
  marketplace: '/marketplace',  
  orders: '/ordenes',
  cotizaciones: '/cotizaciones',
  suppliers: '/proveedores',
  supplierCatalog: '/proveedor',
  newOrder: '/nueva/orden',
  users: '/users',
  places: '/locales',
  resetPassword: '/resetPassword',
  report: '/reportes',
  products: '/productos',
  documents: '/documentos',
  chart:'/graficos'
};

 